export const viewsMixin = {
    methods: {
        formatViews: function (views) {
            if (views >= 1000000000) { return '1b+ views' }
            if (views >= 100000000) { return '100m+ views' }
            if (views >= 10000000) { return '10m+ views' }
            if (views >= 1000000) { return '1m+ views' }
            if (views >= 100000) { return '100k+ views' }
            if (views >= 10000) { return '10k+ views' }
            if (views >= 1000) { return '1k+ views' }
            if (views >= 100) { return '100+ views' }
            if (views >= 10) { return '10+ views' }
            return 'new'
        }
    }
}